import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AccountService } from './account.service';

@Injectable()
export class NotificationCountersService {
  sub: Subscription;

  public reviewsCount: BehaviorSubject<number> = new BehaviorSubject<number>(
    null,
  );
  public todosCount: BehaviorSubject<number> = new BehaviorSubject<number>(
    null,
  );

  // -------------------------------------------------------------------
  constructor(private accountService: AccountService) {}

  // -------------------------------------------------------------------
  public refresh(accountId) {
    this.reviewsCount.next(null);
    this.todosCount.next(null);

    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.accountService
      .notificationCounters(accountId)
      .subscribe(account => {
        this.reviewsCount.next(account.totalReviews);
        this.todosCount.next(
          account.totalReviews
        );
      });
  }
}
